export default {"src":"/_next/static/media/five-star.39d19a01.svg","height":130,"width":881};